// api/hrm/employees/employeeInfo.js
import axiosInstance from "../../axiosInstance";
const BASE_URL = '/hrm/employees';

export const getAllEmployees = async (params = {}) => {
  try {
    const query = new URLSearchParams(params).toString();
    const response = await axiosInstance.get(`${BASE_URL}?${query}`);
    return response.data;
  } catch (error) {
    console.error('Lỗi khi lấy danh sách nhân viên:', error);
    return { data: [], total: 0 };
  }
};

// 🔹 Lấy toàn bộ nhân viên kinh doanh hiện hành
export const getAllSalesEmployees = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/sales-employees`, {
      skipGlobalErrorToast: true,
    });
    return response.data || [];
  } catch (error) {
    console.error("Lỗi khi lấy toàn bộ danh sách nhân viên kinh doanh:", error);
    return [];
  }
};


// 🔹 Lấy toàn bộ nhân viên (không phân trang, không bộ lọc)
export const getAllEmployeesNoPageNoFilter = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/all-no-page-no-filter`);
    const data = response.data;

    // Nếu backend trả array → convert về items để CRM dùng
    if (Array.isArray(data)) {
      return {
        items: data,
        total: data.length
      };
    }

    // Nếu backend trả object dạng { items: [...] } → giữ nguyên
    return data;

  } catch (error) {
    console.error("Lỗi khi lấy toàn bộ danh sách nhân viên:", error);
    return { items: [], total: 0 };
  }
};




// 🔹 Lấy toàn bộ nhân viên (không phân trang, có bộ lọc)
export const getAllEmployeesNoPageHasFilter = async (params = {}) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/all-no-page-has-filter`,
      { params, skipGlobalErrorToast: true }
    );

    const data = response.data;

    // Trường hợp backend trả dạng { data: [...] }
    if (data && Array.isArray(data.data)) {
      return {
        items: data.data,
        total: data.data.length
      };
    }

    // Trường hợp backend trả trực tiếp array []
    if (Array.isArray(data)) {
      return {
        items: data,
        total: data.length
      };
    }

    // Trường hợp backend trả đúng { items: [...] }
    if (data && Array.isArray(data.items)) {
      return {
        items: data.items,
        total: data.items.length
      };
    }

    // Trường hợp fallback
    return { items: [], total: 0 };

  } catch (error) {
    console.error("Lỗi khi lấy toàn bộ danh sách nhân viên:", error);
    return { items: [], total: 0 };
  }
};



// 🔹 Lấy toàn bộ nhân viên (không phân trang)
export const getAllEmployeesIsActive = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/is-active`);
    return response.data || [];
  } catch (error) {
    console.error("Lỗi khi lấy toàn bộ danh sách nhân viên đang hoạt động:", error);
    return [];
  }
};


// 🔹 Lấy danh sách nhân viên theo chi nhánh và phòng ban
export const getEmployeesFilter = async ({ branch_id, department_id } = {}) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/filter`, {
      params: { branch_id, department_id }
    });
    return res.data || [];
  } catch (error) {
    console.error("Lỗi khi lấy danh sách nhân viên:", error);
    return [];
  }
};



// 🔹 Lấy danh sách giáo viên theo chi nhánh
export const getTeachersByBranch = async (branch_id) => {
  try {
    if (!branch_id) return [];

    const res = await axiosInstance.get(
      `${BASE_URL}/teachers`,
      { params: { branch_id } }
    );

    return Array.isArray(res.data)
      ? res.data
      : Array.isArray(res.data.items)
      ? res.data.items
      : [];

  } catch (error) {
    console.error("Lỗi khi lấy danh sách giáo viên:", error);
    return [];
  }
};





// 🔹 Lấy mã nhân viên tiếp theo
export const getNextEmployeeCode = async () => {
  try {
    const response = await axiosInstance.get(`${BASE_URL}/next-code`);
    return response.data.code;
  } catch (error) {
    console.error('Không lấy được mã nhân viên:', error);
    return '';
  }
};

// 🔹 Lấy thông tin nhân viên theo ID
export const getEmployeeById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

// 🔹 Tạo nhân viên mới
export const createEmployee = async (data) => {
  try {
    const response = await axiosInstance.post(BASE_URL, data);
    return response.data;
  } catch (error) {
    console.error('Lỗi khi tạo nhân viên:', error);
    throw error;
  }
};

// 🔹 Đổi mật khẩu
export const changePassword = async (id, oldPassword, newPassword) => {
  try {
    const response = await axiosInstance.post(`${BASE_URL}/change-password`, {
      id,
      oldPassword,
      newPassword,
    });
    return response.data; // { message: "Đổi mật khẩu thành công." }
  } catch (error) {
    console.error('Lỗi khi đổi mật khẩu:', error);
    throw error.response?.data || { message: 'Lỗi kết nối server' };
  }
};

// 🔹 Cập nhật thông tin nhân viên
export const updateEmployee = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật nhân viên:", error);
    throw error;
  }
};

// 🔹 Xóa nhân viên theo ID
export const deleteEmployee = async (id) => {
  try {
    const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error("Lỗi khi xóa nhân viên:", error);
    throw error;
  }
};

// 🔹 Cập nhật trạng thái tài khoản (Đóng / Mở)
export const toggleEmployeeStatus = async (id, isActive) => {
  try {
    const response = await axiosInstance.patch(`${BASE_URL}/${id}/status`, {
      is_active: isActive,
    });
    return response.data;
  } catch (error) {
    console.error('Lỗi khi cập nhật trạng thái tài khoản:', error);
    throw error;
  }
};


// --- Hợp đồng lao động (lương / phụ cấp) — cần quyền hrm.employees_sensitive ---
export const getEmployeeContracts = async (employee_id) => {
  const res = await axiosInstance.get("/hrm/employee-contracts", {
    params: { employee_id },
  });
  return res.data?.records || [];
};

export const createEmployeeContract = async (payload) => {
  const res = await axiosInstance.post("/hrm/employee-contracts", payload);
  return res.data;
};

export const updateEmployeeContract = async (id, payload) => {
  const res = await axiosInstance.put(`/hrm/employee-contracts/${id}`, payload);
  return res.data;
};

export const deleteEmployeeContract = async (id) => {
  const res = await axiosInstance.delete(`/hrm/employee-contracts/${id}`);
  return res.data;
};

// --- Tài liệu hồ sơ nhân sự (HĐLĐ, hồ sơ xin việc, PV, …) — hrm.employees_sensitive ---
export const getEmployeeHrDocuments = async (employee_id, params = {}) => {
  const res = await axiosInstance.get("/hrm/employee-hr-documents", {
    params: { employee_id, ...params },
  });
  return res.data?.records || [];
};

export const uploadEmployeeHrDocument = async ({
  employee_id,
  file,
  doc_type = "other",
  title = "",
  note = "",
}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("employee_id", employee_id);
  formData.append("doc_type", doc_type);
  if (title) formData.append("title", title);
  if (note) formData.append("note", note);
  const res = await axiosInstance.post("/hrm/employee-hr-documents", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120_000,
  });
  return res.data?.record || res.data;
};

export const deleteEmployeeHrDocument = async (id) => {
  const res = await axiosInstance.delete(`/hrm/employee-hr-documents/${id}`);
  return res.data;
};

// 🔹 Upload ảnh avatar lên Google Cloud Storage (GCS)
export const uploadEmployeeAvatar = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(`${BASE_URL}/upload-avatar`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // BE trả về { url: "https://storage.googleapis.com/ima-erp-files/avatars/..." }
    return response.data.url;
  } catch (error) {
    console.error("❌ Lỗi khi upload avatar GCS:", error);
    throw error;
  }
};



